import { createSlice } from '@reduxjs/toolkit';

import { MiniGamesDetails, ParticipantDetails } from 'utils/ParticipantAPI';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface User {
    name: string
}
export interface UserState {
  user: User | null,
  participantViewState: string | null
  participantDetails: ParticipantDetails | null
  isAuthChecked: boolean
  miniGamesDetails: MiniGamesDetails | null
}

const initialState: UserState = {
    user: null,
    participantViewState: null,
    participantDetails: null,
    isAuthChecked: false,
    miniGamesDetails: null,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<User | null>) => {
            state.user = action.payload;
        },
        setParticipantViewState: (state, action: PayloadAction<string | null>) => {
            state.participantViewState = action.payload;
        },
        setParticipantDetails: (state, action: PayloadAction<ParticipantDetails | null>) => {
            state.participantDetails = action.payload;
        },
        setMiniGamesDetails: (state, action: PayloadAction<MiniGamesDetails | null>) => {
            state.miniGamesDetails = action.payload;
        },
        setIsAuthChecked: (state, action: PayloadAction<boolean>) => {
            state.isAuthChecked = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setUser, setParticipantViewState, setParticipantDetails, setIsAuthChecked, setMiniGamesDetails } = userSlice.actions;

export default userSlice.reducer;